import { Status } from '@philips-emr/tws-constants';
import { AwesomeEvent, ComponentAPI } from '@philips-emr/tws-core';
import Clickable, { ClickEventListener } from '@philips-emr/tws-core/lib/component/types/clickable';

export interface EventTokenData {
  status: Status;
  subtitle: string;
  title: string;
}

class EventTokenListAPI extends ComponentAPI implements Clickable {

  /** @event */
  @AwesomeEvent
  onClick = new ClickEventListener();

  /** @event */
  @AwesomeEvent
  onDoubleClick = new ClickEventListener();

  /** @event */
  @AwesomeEvent
  onContextMenuClick = new ClickEventListener();

  getData(): EventTokenData[] {
    return this.state.data;
  }

  setData(data: EventTokenData[]): void {
    if (Array.isArray(data)) {
      this.setState({ data });
    }
  }

  getDisplayQuantity(): number {
    return this.state.displayQuantity;
  }

  setDisplayQuantity(displayQuantity: number): void {
    this.setState({ displayQuantity });
  }

}

export default EventTokenListAPI;
